const moneyFormat = '${{ amount }}';

function formatMoney$1(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);

    let centsAmount = '';
    if (parts[1]) {
      if (parts[1] !== '00') {
        centsAmount = decimal + parts[1];
      }
    }

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

var UpsellPopupProduct = class extends HTMLElement {
  constructor() {
    super();
    this.productInput = this.querySelector('input.upsell-product-input');
    this.addButton = this.querySelector('button.upsell-popup-add-button');
    this.removeButton = this.querySelector('button.upsell-popup-remove-button');
    this.variantId = this.dataset.variantId;
    this.shortDescriptionEl = this.querySelector('span.short-description-text');
    this.defaultTitle = this.shortDescriptionEl?.textContent;
    this.texts = {
      textAdded: this.dataset.textAdded,
      textAdd: this.dataset.textAdd,
    };
  }

  connectedCallback() {
    this.addButton?.addEventListener('click', this.addProduct.bind(this));
    this.removeButton?.addEventListener('click', this.removeProduct.bind(this));
  }

  disconnectedCallback() {
    this.addButton?.removeEventListener('click', this.addProduct);
    this.removeButton?.removeEventListener('click', this.removeProduct);
  }

  updateDescription(variantTitle) {
    if (this.defaultTitle) {
      let newTitle = this.defaultTitle.replace('$$$', variantTitle);
      this.shortDescriptionEl.innerHTML = newTitle;
    }
  }

  addProduct() {
    this.classList.add('added');
    this.addButton.disabled = true;
    this.productInput.value = this.variantId;
    this.textEl = this.addButton.querySelector('span.button-text');
    this.textEl.innerHTML = this.texts.textAdded;
  }

  removeProduct() {
    this.classList.remove('added');
    this.addButton.disabled = false;
    this.productInput.value = '';
    this.textEl = this.addButton.querySelector('span.button-text');
    this.textEl.innerHTML = this.texts.textAdded;
  }
};
if (!window.customElements.get('upsell-popup-product')) {
  window.customElements.define('upsell-popup-product', UpsellPopupProduct);
}

var StickyProductForm = class extends HTMLElement {
  constructor() {
    super();
    this.stickyFormSubmitButton = this.querySelector('.product-form__cart-submit.btn');
    this.stickyBisModal = this.querySelector('.cb_BISModal_trigger');
    this.atcButton = document.querySelector(
      '.main-product-section .product__meta .product-form-wrapper form.product-form button.product-form__cart-submit',
    );
    this.soldOutLabel = this.dataset.outOfStockLabel;
    this.inStockLabel = this.dataset.inStockLabel;
  }

  connectedCallback() {
    this.stickyFormSubmitButton?.addEventListener('click', this.addToCart.bind(this));
    document.addEventListener('change', (e) => {
      if (e.target.closest('.main-product-section')) {
        setTimeout(() => this.update(), 50);
      }
    });
    document.addEventListener('click', (e) => {
      if (e.target.closest('.main-product-section .product__color-swatch')) {
        setTimeout(() => this.update(), 50);
      }
    });
  }

  update() {
    const priceElement = this.stickyFormSubmitButton?.querySelector('.product__price .price-text');
    if (priceElement) {
      const mainPrice = document.querySelector('.main-product-section .product__price .price-text');
      if (mainPrice) {
        priceElement.textContent = mainPrice.textContent;
      }
    }
    const isDisabled = this.atcButton?.disabled;
    const buttonText = this.stickyFormSubmitButton?.querySelector('span');
    if (isDisabled) {
      this.stickyFormSubmitButton?.setAttribute('disabled', '');
      this.stickyFormSubmitButton?.classList.add('visually-hidden');
      this.stickyBisModal?.classList.remove('visually-hidden');
      if (buttonText) buttonText.textContent = this.soldOutLabel;
    } else {
      this.stickyFormSubmitButton?.removeAttribute('disabled');
      this.stickyFormSubmitButton?.classList.remove('visually-hidden');
      this.stickyBisModal?.classList.add('visually-hidden');
      if (buttonText) buttonText.textContent = this.inStockLabel;
    }
  }

  addToCart() {
    this.stickyFormSubmitButton?.classList.add('loading');
    this.atcButton?.click();
    setTimeout(() => {
      this.stickyFormSubmitButton?.classList.remove('loading');
    }, 1500);
  }
};

if (!window.customElements.get('sticky-product-form')) {
  window.customElements.define('sticky-product-form', StickyProductForm);
}

var SeparateStickyAtcForm = class extends HTMLElement {
  constructor() {
    super();

    this.mode = this.dataset.mode;
    this.isBundleProduct = this.dataset.isBundleProduct === 'true';
    this.inStockLabel = this.dataset.inStockLabel || '';
    this.outOfStockLabel = this.dataset.outOfStockLabel || '';

    this.sectionRoot = this.closest('.main-product-section');
    this.mainForm = this.sectionRoot?.querySelector('.product__meta .main-product-form-wrapper form.product-form');
    this.mainButton = this.mainForm?.querySelector('button.product-form__cart-submit');
    this.mainNotifyButton = this.sectionRoot?.querySelector('.cb_BISModal_trigger button');

    this.stickyButton = this.querySelector('.js-separate-sticky-atc-button');
    this.stickyNotifyButton = this.querySelector('.js-separate-sticky-notify');

    this.boundUpdate = this.update.bind(this);
    this.boundHandleClick = this.handleClick.bind(this);
    this.boundHandleNotifyClick = this.handleNotifyClick.bind(this);
    this.boundHandleChange = this.handleChange.bind(this);
    this.boundHandleColorSwatchClick = this.handleColorSwatchClick.bind(this);
  }

  connectedCallback() {
    if (this.mode === 'hide' || !this.mainForm || !this.mainButton || !this.stickyButton) {
      return;
    }

    this.stickyButton.addEventListener('click', this.boundHandleClick);
    this.stickyNotifyButton?.addEventListener('click', this.boundHandleNotifyClick);

    window.addEventListener('scroll', this.boundUpdate, { passive: true });
    window.addEventListener('resize', this.boundUpdate);

    document.addEventListener('change', this.boundHandleChange);
    document.addEventListener('click', this.boundHandleColorSwatchClick);

    this.update();
  }

  disconnectedCallback() {
    this.stickyButton?.removeEventListener('click', this.boundHandleClick);
    this.stickyNotifyButton?.removeEventListener('click', this.boundHandleNotifyClick);

    window.removeEventListener('scroll', this.boundUpdate);
    window.removeEventListener('resize', this.boundUpdate);
    document.removeEventListener('change', this.boundHandleChange);
    document.removeEventListener('click', this.boundHandleColorSwatchClick);
  }

  handleChange(e) {
    if (e.target.closest('.main-product-section') === this.sectionRoot) {
      setTimeout(this.boundUpdate, 50);
    }
  }

  handleColorSwatchClick(e) {
    if (e.target.closest('.main-product-section .product__color-swatch')) {
      setTimeout(this.boundUpdate, 50);
    }
  }

  handleClick() {
    const bundleTarget = document.querySelector('[data-bundle-scroll-target]');

    if (this.isBundleProduct && bundleTarget) {      
      bundleTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
      
      return;
    }

    if (!this.mainButton?.disabled) {
      this.stickyButton.classList.add('loading');
      this.mainButton.click();
      setTimeout(() => {
        this.stickyButton?.classList.remove('loading');
      }, 1200);
    }
  }

  handleNotifyClick() {
    this.mainNotifyButton?.click();
  }

  update() {
    if (!this.mainForm || !this.mainButton || !this.stickyButton) {
      return;
    }

    const isMainDisabled = this.mainButton.disabled;
    this.stickyButton.disabled = isMainDisabled;

    if (this.stickyButton.innerHTML !== this.mainButton.innerHTML) {
      this.stickyButton.innerHTML = this.mainButton.innerHTML;
    }

    const isUnavailable = this.mainButton.classList.contains('visually-hidden') || this.mainButton.getAttribute('aria-disabled') === 'true';

    if (this.stickyNotifyButton) {
      if (isUnavailable) {
        this.stickyNotifyButton.classList.remove('visually-hidden');
        this.stickyButton.classList.add('visually-hidden');
      } else {
        this.stickyNotifyButton.classList.add('visually-hidden');
        this.stickyButton.classList.remove('visually-hidden');
      }
    }

    const rect = this.mainForm.getBoundingClientRect();
    const formBottom = rect.top + window.pageYOffset + rect.height;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > formBottom) {
      this.classList.add('separate-sticky-atc--visible');
    } else {
      this.classList.remove('separate-sticky-atc--visible');
    }
  }
};

if (!window.customElements.get('separate-sticky-atc-form')) {
  window.customElements.define('separate-sticky-atc-form', SeparateStickyAtcForm);
}

var VideoMedia = class extends HTMLElement {
  constructor() {
    super();
    this.playPauseButton = this.querySelector('button.play-pause-button');
    this.muteUnmuteButton = this.querySelector('button.mute-unmute-button');
    this.video = this.querySelector('video');
  }

  connectedCallback() {
    this.muteUnmuteButton?.addEventListener('click', this.muteUnmuteVideo.bind(this));
  }

  disconnectedCallback() {
    this.muteUnmuteButton?.removeEventListener('click', this.muteUnmuteVideo);
  }

  async playPauseVideo() {
    if (this.video.paused || this.video.ended) {
      await this.pauseAllVideos();
      this.video.play();
      this.changeButtonIcon('play');
    } else {
      this.pauseVideo();
    }
  }

  async pauseAllVideos() {
    let sectionVideos = this.closest('.section').querySelectorAll('video-media');
    await Promise.all(Array.from(sectionVideos).map((videoMedia) => videoMedia.pauseVideo()));
  }

  pauseVideo() {
    if (!this.video.paused) {
      this.video.pause();
      this.changeButtonIcon('pause');
    }
  }

  muteUnmuteVideo() {
    this.video.muted = !this.video.muted;
    if (this.video.muted) {
      this.changeButtonIcon('unmute');
    } else {
      this.changeButtonIcon('mute');
    }
  }

  changeButtonIcon(buttonState) {
    let buttonIcon;
    switch (buttonState) {
      case 'play':
        buttonIcon = this.playPauseButton.querySelector('.play-pause-icon');
        buttonIcon?.classList.remove('pause');
        buttonIcon?.classList.add('play');
        break;

      case 'pause':
        buttonIcon = this.playPauseButton.querySelector('.play-pause-icon');
        buttonIcon?.classList.remove('play');
        buttonIcon?.classList.add('pause');
        break;

      case 'unmute':
        buttonIcon = this.muteUnmuteButton.querySelector('.mute-unmute-icon');
        buttonIcon?.classList.remove('mute');
        buttonIcon?.classList.add('unmute');
        break;

      case 'mute':
        buttonIcon = this.muteUnmuteButton.querySelector('.mute-unmute-icon');
        buttonIcon?.classList.remove('unmute');
        buttonIcon?.classList.add('mute');
        break;

      default:
        return;
    }
  }
};

if (!window.customElements.get('video-media')) {
  window.customElements.define('video-media', VideoMedia);
}

var QuantityPicker = class extends HTMLElement {
  constructor() {
    super();
    this.buttonIncrease = this.querySelector('.product__quantity-add-item');
    this.inStickyForm = this.dataset.inStickyProductForm ? true : false;
    this.buttonDecrease = this.querySelector('.product__quantity-subtract-item');
    this.quantityPickerInput = this.querySelector('.quantity-input__input');
    this.atcFormQuantityInput = this.closest('.product-form-wrapper').querySelector(
      'form .product-form__quantity > input.product-form__input--quantity',
    );

    if (this.inStickyForm) {
      this.atcFormButtonIncrease = document.querySelector(
        '.main-product-section .product__meta .product-form-wrapper .product__quantity-add-item',
      );
      this.atcFormButtonDecrease = document.querySelector(
        '.main-product-section .product__meta .product-form-wrapper .product__quantity-subtract-item',
      );
    }
  }

  connectedCallback() {
    this.buttonIncrease.addEventListener('click', this.quantityIncrease.bind(this));

    this.buttonDecrease.addEventListener('click', this.quantityDecrease.bind(this));
    if (!this.inStickyForm) {
      this.quantityPickerInput.addEventListener('change', this.updateProductQuantity.bind(this));
    }
  }

  disconnectedCallback() {
    this.buttonIncrease.removeEventListener('click', this.quantityIncrease);

    this.buttonDecrease.removeEventListener('click', this.quantityDecrease);

    if (!this.inStickyForm) {
      this.quantityPickerInput.removeEventListener('change', this.updateProductQuantity);
    }
  }

  quantityIncrease(event) {
    event.preventDefault();
    this.quantityPickerInput.stepUp();
    if (this.inStickyForm) {
      this.atcFormButtonIncrease.dispatchEvent(new Event('click'));
    } else {
      this.quantityPickerInput.dispatchEvent(new Event('change'));
    }
  }

  quantityDecrease(event) {
    event.preventDefault();
    this.quantityPickerInput.stepDown();
    if (this.inStickyForm) {
      this.atcFormButtonDecrease.dispatchEvent(new Event('click'));
    } else {
      this.quantityPickerInput.dispatchEvent(new Event('change'));
    }
  }

  updateProductQuantity(event) {
    event.preventDefault();
    this.atcFormQuantityInput.value = this.quantityPickerInput.value;
  }
};

if (!window.customElements.get('quantity-picker')) {
  window.customElements.define('quantity-picker', QuantityPicker);
}

var VariantSelector = class extends HTMLElement {
  constructor() {
    super();
    this.inStickyProductForm = this.dataset.inStickyProductForm ? true : false;
    this.inCrossSell = this.dataset.inCrossSell ? true : false;
    this.isStyleOption = this.dataset.styleOption ? true : false;
    this.selectOpener = this.querySelector('.select-opener');
    this.selectOptions = this.querySelectorAll('.select-option-button');
    this.selectOptionsWrapper = this.querySelector('.option-select-dropdown-buttons');
    if (this.isStyleOption) {
      this.variantSelectInput = document.querySelector('#option1');
    }
    if (this.inCrossSell) {
      this.priceWrapper = this.closest('.cross-sells__item-details').querySelector('.product__price');
      this.atcFormVariantSelectDesktop =
        this.closest('.cross-sells__item-content').querySelector('button.cross-sells__item-add');
      this.atcFormVariantSelectMobile = this.closest('.cross-sells__item-content').querySelector(
        'button.cross-sells__item-add-mobile',
      );
      this.urlElement = this.closest('.cross-sells__item-content').querySelector('.cross-sells__item-title > a');
      this.baseURL = this.urlElement.href;
    } else {
      if (this.inStickyProductForm) {
        this.stickyProductForm = this.closest('sticky-product-form');
        this.atcFormVariantSelect = document.querySelector('.main-product-section .product__color-swatches');
        this.variantFormIsSelect = false;
        if (!this.atcFormVariantSelect) {
          this.atcFormVariantSelect = document.querySelector(
            '.main-product-section .product__variants-wrapper .input.dynamic-variant-input',
          );
          this.variantFormIsSelect = true;
        }
      } else {
        this.priceWrapper = this.closest('.sticky-product-form-section').querySelector(
          '.product-form__cart-submit .product__price',
        );
        this.atcFormVariantSelect =
          this.closest('.sticky-product-form-section').querySelector('.product-form select.input');
      }
    }
  }

  connectedCallback() {
    this.selectOpener.addEventListener('click', this.openCloseOptionSelect.bind(this));

    this.selectOptions.forEach((optionButton) => {
      if (this.inStickyProductForm) {
        optionButton.addEventListener('click', this.stickyFormUpdateSelectedOption.bind(this));
      } else {
        optionButton.addEventListener('click', this.updateSelectedOption.bind(this));
      }
    });
  }

  disconnectedCallback() {
    this.selectOpener.removeEventListener('click', this.openCloseOptionSelect);

    this.selectOptions.forEach((optionButton) => {
      if (this.inStickyProductForm) {
        optionButton.removeEventListener('click', this.stickyFormUpdateSelectedOption);
      } else {
        optionButton.removeEventListener('click', this.updateSelectedOption);
      }
    });
  }

  openCloseOptionSelect() {
    if (this.selectOptionsWrapper.classList.contains('opened')) {
      this.closeOptionSelect();
    } else {
      this.openOptionSelect();
    }
  }

  stickyFormUpdateSelectedOption(event) {
    event.preventDefault();
    const target = event.currentTarget;
    let selectedOption = target.dataset.option.toLowerCase();
    let optionName = '';
    if (!this.variantFormIsSelect) {
      let productFormOptions = this.atcFormVariantSelect.querySelectorAll('.product__color-swatch');
      productFormOptions.forEach((option) => {
        optionName = option.dataset.optionValue.toLowerCase();
        if (optionName === selectedOption) {
          option.dispatchEvent(new Event('click'));
        }
      });
    } else {
      if (this.isStyleOption) {
        this.variantSelectInput.value = target.dataset.option;
        this.variantSelectInput.dispatchEvent(new Event('change'));
      } else {
        this.atcFormVariantSelect.value = target.dataset.option;
      }
    }
    if (this.inStickyProductForm) {
      this.stickyProductForm.updateAvailability();
    }
    this.updateSelectOpenerHtml(target);
    this.closeOptionSelect();
    this.updatePDPSlider();
  }

  updatePDPSlider() {
    const selectedVariant = document.querySelector('.product-form select option:checked').value;
    const pdpSwiperContainer = document.querySelector('.product__media-container');

    if (selectedVariant && pdpSwiperContainer) {
      pdpSwiperContainer.querySelectorAll('.product__media-item').forEach((item) => {
        item.classList.add('hide');
      });

      pdpSwiperContainer
        .querySelectorAll(`.product__media-item[data-variant-id~="${selectedVariant}"]`)
        .forEach((item) => {
          item.classList.remove('hide');
          item.classList.remove('hidden');
        });

      pdpSwiperContainer?.swiper?.update();
    }
  }

  updateSelectOpenerHtml(selectedOption) {
    const newSwatchColor = selectedOption.dataset.swatchColor;
    const variantName = selectedOption.dataset.option;
    let swatch = this.selectOpener.querySelector('.bundle-color-swatch');
    let optionText = this.selectOpener.querySelector('.select-opener-text > span:not(.option-name)');
    swatch.style.background = newSwatchColor;
    optionText.innerHTML = variantName;
  }

  updateSelectedOption(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const variantPrice = formatMoney$1(target.dataset.variantPrice, window.theme.moneyFormat);
    if (this.inCrossSell) {
      let newVariantId = target.dataset.variantId;
      let newProductUrl = this.baseURL + `?variant=${newVariantId}`;
      this.urlElement.href = newProductUrl;
      if (this.priceWrapper) {
        this.priceWrapper.querySelector('span.price-text').innerHTML = variantPrice;
      }
      this.atcFormVariantSelectDesktop.dataset.addItemId = newVariantId;
      if (this.atcFormVariantSelectMobile != undefined) {
        this.atcFormVariantSelectMobile.dataset.addItemId = newVariantId;
      }
    } else {
      let newVariantId = target.dataset.variantId;
      this.atcFormVariantSelect.value = newVariantId;
      this.priceWrapper.querySelector('span.price-text').innerHTML = variantPrice;
    }

    this.updateSelectOpenerHtml(target);
    this.closeOptionSelect();
  }

  closeOptionSelect() {
    this.selectOptionsWrapper.classList.remove('opened');
    this.selectOptionsWrapper.style.height = '0px';
  }

  openOptionSelect() {
    let buttonsCount = this.selectOptionsWrapper.querySelectorAll('.select-option-button').length;
    let itemHeight = this.selectOptionsWrapper.querySelector('.select-option-button').offsetHeight * buttonsCount;
    itemHeight = itemHeight + 'px';
    this.selectOptionsWrapper.classList.add('opened');
    this.selectOptionsWrapper.style.height = itemHeight;
  }
};

if (!window.customElements.get('variant-selector')) {
  window.customElements.define('variant-selector', VariantSelector);
}

// Product card swatches
function bindProductCardColorSwatchEvent(swatchesPopup) {
  const overflowSwatchBtns = document.querySelectorAll('span.product-swatches-options__item-overflow');
  const overflowSwatchBtnsMobile = document.querySelectorAll('span.product-swatches-options__item-overflow-mobile');
  const colorSwatches = document.querySelectorAll(
    'li.product-swatches-options__item--swatch:not(.product-swatches-options__item-overflow)',
  );
  const firstVariantSelected = document.querySelectorAll('div.product-item__meta[data-is-first-variant-selected]');

  if (firstVariantSelected.length > 0) {
    firstVariantSelected.forEach((container) => {
      const firstSwatch = container.querySelectorAll('li.product-swatches-options__item--swatch');
      if (firstSwatch.length > 0) {
        swatchSetActive(firstSwatch[0]);
      }
    });
  }

  if (overflowSwatchBtnsMobile.length > 0) {
    overflowSwatchBtnsMobile.forEach((btn) => {
      if (!btn.dataset.popupEventBound) {
        btn.addEventListener('click', () => {
          const productItem = btn.closest('.product-item');
          const productPopup = productItem.querySelector('.product-item__variant-info-popup');
          if (productPopup) {
            showProductVariants(productPopup);
          }
        });
        btn.dataset.popupEventBound = 'true';
      }
    });
  }

  if (overflowSwatchBtns.length > 0) {
    overflowSwatchBtns.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        showHideColorSwatches(event.target);
        showHideTotalSwatchCount(event.target);
        event.target.classList.toggle('minus');
      });
    });
  }

  colorSwatches.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      swatchSetActive(event.target);
    });
  });
}

function showHideColorSwatches(target) {
  if (target === null) return;

  const swatchesOptionsWrapper = target.closest('.product-swatches-options');
  const swatches = swatchesOptionsWrapper.querySelectorAll('li.overflow');
  const singleSwatch = swatchesOptionsWrapper.querySelector('.product-swatches-options__item--swatch');
  const swatchesWrapper = swatchesOptionsWrapper.querySelector('.product-swatches-options__list');
  const maxVisible = swatchesOptionsWrapper.dataset.maxVisible;
  const maxVisibleMobile = swatchesOptionsWrapper.dataset.maxVisibleMobile;

  let style = singleSwatch.currentStyle || window.getComputedStyle(singleSwatch);
  let swatchMargin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
  let swatchWidth = singleSwatch.offsetWidth + swatchMargin;
  let fullWidth = swatchWidth * swatches.length + swatchWidth * maxVisible;
  fullWidth = fullWidth + 'px';
  let initWidth = swatchWidth * maxVisible;
  initWidth = initWidth + 'px';

  let initWidthMobile = swatchWidth * maxVisibleMobile;
  initWidthMobile = initWidthMobile + 'px';

  if (window.innerWidth < 990) {
    swatchesWrapper.style.width = initWidthMobile;
  }

  if (swatchesWrapper.classList.contains('swatches-hidden')) {
    setTimeout(() => {
      swatchesWrapper.classList.remove('swatches-hidden');
    }, 250);

    swatchesWrapper.style.width = fullWidth;
  } else {
    swatchesWrapper.classList.add('swatches-hidden');
    swatchesWrapper.style.width = initWidth;
  }

  swatches.forEach((swatch) => {
    swatch.classList.toggle('overflown-swatch');
  });
}

function showProductVariants(swatchesPopup) {
  const swatchesPopupMainWrapper = document.querySelector('.swatches-popup-main-wrapper');
  const originalSwatchesPopup = swatchesPopup.cloneNode(true);

  originalSwatchesPopup.style.maxHeight = '0px';
  originalSwatchesPopup.style.opacity = '0';
  originalSwatchesPopup.style.visibility = 'hidden';
  originalSwatchesPopup.classList.add('active-swatches-popup');

  swatchesPopupMainWrapper.appendChild(originalSwatchesPopup);

  requestAnimationFrame(() => {
    originalSwatchesPopup.style.maxHeight = originalSwatchesPopup.scrollHeight + 'px';
    originalSwatchesPopup.style.opacity = '1';
    originalSwatchesPopup.style.visibility = 'visible';
  });

  setTimeout(() => {
    originalSwatchesPopup.style.removeProperty('max-height');
  }, 500);

  const popupOverlay = document.createElement('div');
  swatchesPopupMainWrapper.appendChild(popupOverlay);
  popupOverlay.classList.add('popup-overlay');

  //swatchesPopup.remove();

  const productId = swatchesPopup.querySelector('.product-swatches-options__list').dataset.productId;
  const mainProductActiveSwatch = document.querySelector(
    `.product-item .product-item__inner .product-swatches-options__item--swatch.active[data-product-id="${productId}"]`,
  );

  if (mainProductActiveSwatch) {
    const mainProductActiveSwatchId = mainProductActiveSwatch.dataset.variantid;
    const popupProductActiveSwatch = swatchesPopupMainWrapper.querySelector(
      `.product-item__variant-info-popup .product-swatches-options__item--swatch[data-variantid="${mainProductActiveSwatchId}"]`,
    );

    if (popupProductActiveSwatch) {
      swatchSetActiveInPopup(popupProductActiveSwatch);
    }
  }

  const colorSwatches = swatchesPopupMainWrapper.querySelectorAll('li.product-swatches-options__item--swatch');

  colorSwatches.forEach((btn) => {
    btn.addEventListener('click', (event) => {
      swatchSetActiveInPopup(event.target);
    });
  });

  closeSwatchesPopup(originalSwatchesPopup, popupOverlay);
}

function closeSwatchesPopup(swatchesPopup, popupOverlay) {
  const closeBtn = swatchesPopup.querySelector('.product-title-close_button');

  popupOverlay.addEventListener('click', () => {
    swatchesPopup.style.maxHeight = '0px';

    setTimeout(() => {
      swatchesPopup.style.padding = '0';
    }, 500);

    setTimeout(() => {
      swatchesPopup.style.opacity = '0';
      swatchesPopup.style.visibility = 'hidden';
      swatchesPopup.remove();
      popupOverlay.remove();
    }, 1000);
  });

  closeBtn.addEventListener('click', () => {
    swatchesPopup.style.maxHeight = '0px';

    setTimeout(() => {
      swatchesPopup.style.padding = '0';
    }, 500);

    setTimeout(() => {
      swatchesPopup.style.opacity = '0';
      swatchesPopup.style.visibility = 'hidden';
      swatchesPopup.remove();
      popupOverlay.remove();
    }, 1000);
  });
}

function swatchSetActive(target) {
  if (target === null) return;
  const normalizedTarget = target.closest('li.product-swatches-options__item--swatch');
  if (!normalizedTarget) return;
  target = normalizedTarget;

  const colorSwatchWrapper = target.closest('ul.product-swatches-options__list');
  const allColorSwatches = colorSwatchWrapper.querySelectorAll('li.product-swatches-options__item--swatch');
  const productItem = target.closest('.product-item');
  const productItemAtcButton = productItem.querySelector('.product-form__cart-submit');
  let productItemAtcButtonText = null;
  if (productItemAtcButton) {
    productItemAtcButtonText = productItemAtcButton.querySelectorAll('[data-add-to-cart-text]');
  }
  const productItemVariantQuantityPicker = productItem.querySelector('.product__controls-group-quantity');

  const formProduct = productItem.querySelector('form.product-form.product-form-not-popup');
  const productSelector = formProduct.querySelector('select#variant-selector');
  const productSelectorOptions = productSelector.querySelectorAll('option');

  allColorSwatches.forEach((swatch) => {
    swatch.classList.remove('active');
  });

  target.classList.toggle('active');

  if (!target.dataset.inStickyHeader) {
    updateProductCardLink(target, target.dataset.variantid);
    updateProductCardImage(target, target.dataset.variantImage);
    updateProductCardTitle(target, target.dataset.variantTitle);
    updateProductCardPrice(target, target.dataset.variantPrice);
    updateProductCardCustomBadges(target);
    if (target.dataset.variantAvailable === 'true') {
      if (productItemAtcButton) {
        productItemAtcButton.removeAttribute('disabled');
        productItemAtcButton.classList.remove('visually-hidden');
      }

      const formattedVariantPrice = formatMoney$1(target.dataset.variantPrice, window.theme.moneyFormat);

      if (productItemAtcButtonText) {
        productItemAtcButtonText.forEach((text) => {
          text.textContent = productItemAtcButton.dataset.langAvailableFor + ' ' + formattedVariantPrice;
        });
      }

      if (formProduct) {
        formProduct.dataset.productId = target.dataset.variantid;
      }

      productSelectorOptions.forEach((option) => {
        option.removeAttribute('selected');
        if (option.value === target.dataset.variantid) {
          option.setAttribute('selected', 'selected');
        }
      });

      productItem.classList.remove('visible-notify-me-button');
      productItem.classList.add('visible-notify-me-button-not-visible');

      if (productItemAtcButton) {
        productItemAtcButton.querySelector('.icon.icon-header-shopping-cart')?.classList.remove('icon-disabled');
        productItemVariantQuantityPicker?.classList.remove('hide-variant-quantity-picker');
      }
    } else {
      if (productItemAtcButton) {
        productItemAtcButton.setAttribute('disabled', 'disabled');
        productItemAtcButton.classList.add('visually-hidden');
      }
      if (productItemAtcButtonText) {
        productItemAtcButtonText.forEach((text) => {
          text.textContent = productItemAtcButton.dataset.langUnavailable;
        });
      }
      if (productItemAtcButton) {
        productItemAtcButton.querySelector('.icon.icon-header-shopping-cart')?.classList.add('icon-disabled');
        productItemVariantQuantityPicker?.classList.add('hide-variant-quantity-picker');
      }

      productItem.classList.add('visible-notify-me-button');
      productItem.classList.remove('visible-notify-me-button-not-visible');
    }
  }
}

function swatchSetActiveInPopup(target) {
  if (target === null) return;
  const normalizedTarget = target.closest('li.product-swatches-options__item--swatch');
  if (!normalizedTarget) return;
  target = normalizedTarget;

  const colorSwatchWrapper = target.closest('ul.product-swatches-options__list');
  const allColorSwatches = colorSwatchWrapper.querySelectorAll('li.product-swatches-options__item--swatch');
  const productItem = target.closest('.product-item__variant-info-popup');
  const productItemAtcButton = productItem.querySelector('.product-form__cart-submit-swatches-popup');
  const productItemAtcButtonText = productItemAtcButton.querySelectorAll('[data-add-to-cart-text]');

  const swatchesPopupForm = productItemAtcButton.closest('.product-form');

  if (swatchesPopupForm) {
    swatchesPopupForm.dataset.currentProductId = target.dataset.variantid;

    const idInput = swatchesPopupForm.querySelector('[name="id"]');
    if (idInput) {
      idInput.value = target.dataset.variantid;
    }
  }

  allColorSwatches.forEach((swatch) => {
    swatch.classList.remove('active');
  });

  target.classList.toggle('active');

  if (!target.dataset.inStickyHeader) {
    if (target.dataset.variantAvailable === 'true') {
      productItemAtcButton.removeAttribute('disabled');

      const formattedVariantPrice = formatMoney$1(target.dataset.variantPrice, window.theme.moneyFormat);

      productItemAtcButtonText.forEach((text) => {
        text.textContent = productItemAtcButton.dataset.langAvailableFor + ' ' + formattedVariantPrice;
      });
      productItemAtcButton.querySelector('.icon.icon-header-shopping-cart').classList.remove('icon-disabled');
    } else {
      productItemAtcButton.setAttribute('disabled', 'disabled');
      productItemAtcButtonText.forEach((text) => {
        text.textContent = productItemAtcButton.dataset.langUnavailable;
      });
      productItemAtcButton.querySelector('.icon.icon-header-shopping-cart').classList.add('icon-disabled');
    }
  }
}

function setPriceVisibility(target) {
  /* to be reworked */
  let priceWrapper = target.closest('.sticky-product-form-section').querySelector('form .product__price');
  if (variantAvailable != 'false') {
    priceWrapper.classList.remove('visually-hidden');
  } else {
    priceWrapper.classList.add('visually-hidden');
  }
}

function updateProductCardLink(target, targetVaraintID) {
  if (target === null) return;
  if (targetVaraintID === null) return;

  const productCard = target.closest('.product-item__inner');
  const productCardImage = productCard.querySelector('.product-item__image-link');
  const productCardTitle = productCard.querySelector('.product-item__product-title a');
  let productCardImageLink = productCardImage.href;
  let productCardTitleLink = productCardTitle.href;

  if (productCardImageLink.includes('?variant') || productCardTitleLink.includes('?variant')) {
    productCardImage.href = productCardTitleLink.split('?').shift() + '?variant=' + targetVaraintID;
    productCardTitle.href = productCardTitleLink.split('?').shift() + '?variant=' + targetVaraintID;
  } else {
    productCardImage.href = productCardImageLink + '?variant=' + targetVaraintID;
    productCardTitle.href = productCardTitleLink + '?variant=' + targetVaraintID;
  }
}

//update image
function updateProductCardImage(target, targetVariantImage) {
  if (target === null) return;
  if (targetVariantImage === null || targetVariantImage === '') return;

  //get image info
  const productCard = target.closest('.product-item__inner');
  let productCardImage = productCard.querySelector('.image__img');
  let productCard2 = productCard.querySelector('.product-item__image--two');
  let productCardImage2 = productCard2 ? productCard2.querySelector('.image__img') : null;
  let oldsrc = productCardImage.src;
  let srcSet = productCardImage.srcset;
  let imageType, newImageType, newSrc, imageVersion, newImageVersion, src, newSrcSet;

  //check for old image src type
  if (oldsrc.includes('jpg')) {
    imageType = '.jpg';
  } else if (oldsrc.includes('png')) {
    imageType = '.png';
  } else if (oldsrc.includes('webp')) {
    imageType = '.webp';
  } else if (oldsrc.includes('avif')) {
    imageType = '.avif';
  } else if (oldsrc.includes('gif')) {
    imageType = '.gif';
  } else if (oldsrc.includes('svg')) {
    imageType = '.svg';
  } else if (oldsrc.includes('jpeg')) {
    imageType = '.jpeg';
  } else if (oldsrc.includes('heic')) {
    imageType = '.heic';
  } else if (oldsrc.includes('heif')) {
    imageType = '.heif';
  } else if (oldsrc.includes('hevc')) {
    imageType = '.hevc';
  } else if (oldsrc.includes('hevc')) {
    imageType = '.hevc';
  }

  //check for new image src type
  if (targetVariantImage.includes('jpg')) {
    newImageType = '.jpg';
  } else if (targetVariantImage.includes('png')) {
    newImageType = '.png';
  } else if (targetVariantImage.includes('webp')) {
    newImageType = '.webp';
  } else if (targetVariantImage.includes('avif')) {
    newImageType = '.avif';
  } else if (targetVariantImage.includes('gif')) {
    newImageType = '.gif';
  } else if (targetVariantImage.includes('svg')) {
    newImageType = '.svg';
  } else if (targetVariantImage.includes('jpeg')) {
    newImageType = '.jpeg';
  } else if (targetVariantImage.includes('heic')) {
    newImageType = '.heic';
  }

  //strip old src
  src = oldsrc.split('https:').pop();
  src = src.split(imageType).shift();

  //get image version
  imageVersion = oldsrc.split('https:').pop();
  imageVersion = imageVersion.split('?').pop();
  imageVersion = imageVersion.split('&').shift();

  //strip new src
  newSrc = targetVariantImage.split(newImageType).shift();

  //get new image src version
  newImageVersion = targetVariantImage.split('?').pop();
  newImageVersion = newImageVersion.split('&').shift();

  newSrcSet = srcSet.replaceAll(src, newSrc);
  newSrcSet = newSrcSet.replaceAll(imageType, newImageType);
  newSrcSet = newSrcSet.replaceAll(imageVersion, newImageVersion);

  //update src and srcset of the product card image
  productCardImage.src = targetVariantImage;
  productCardImage.srcset = newSrcSet;
  productCardImage.style.objectFit = 'cover';

  //update src and srcset of the product card image 2
  if (productCard2 && productCardImage2) {
    productCardImage2.src = target.dataset.firstCustomVariantImageLink;
    productCardImage2.srcset = '';
    productCardImage2.style.objectFit = 'cover';
  }
}

function updateProductCardCustomBadges(target) {
  if (target === null) return;
  const productCard = target.closest('.product-item');
  if (!productCard) return;

  const productCardBadgesWrapper = productCard.querySelector('.product-badges');
  if (!productCardBadgesWrapper) return;

  let badges = [];
  const {variantCustomBadges, variantCustomBadge, variantCustomBadgeTextColor, variantCustomBadgeBackgroundColor} =
    target.dataset || {};

  if (variantCustomBadges) {
    try {
      const parsed = JSON.parse(variantCustomBadges);
      if (Array.isArray(parsed)) badges = parsed;
    } catch (e) {
      badges = [];
    }
  } else if (typeof variantCustomBadge === 'string' && variantCustomBadge.trim() !== '') {
    badges = [
      {
        text: variantCustomBadge,
        text_color: variantCustomBadgeTextColor || '',
        background_color: variantCustomBadgeBackgroundColor || '',
      },
    ];
  }

  productCardBadgesWrapper.querySelectorAll('.product-badge--variant').forEach((el) => el.remove());

  if (!Array.isArray(badges) || badges.length === 0) return;

  badges.forEach((badge) => {
    if (!badge || typeof badge.text !== 'string' || badge.text.trim() === '') return;
    const badgeEl = document.createElement('div');
    badgeEl.classList.add('product-badge', 'product-badge--variant');
    badgeEl.textContent = badge.text;
    if (badge.text_color) {
      badgeEl.style.color = badge.text_color;
    }
    if (badge.background_color) {
      badgeEl.style.backgroundColor = badge.background_color;
    }
    productCardBadgesWrapper.appendChild(badgeEl);
  });
}

function initializeProductCardBadges() {
  const productItems = document.querySelectorAll('.product-item');
  productItems.forEach((productItem) => {
    const activeOrFirstSwatch =
      productItem.querySelector('li.product-swatches-options__item--swatch.active') ||
      productItem.querySelector('li.product-swatches-options__item--swatch');
    if (activeOrFirstSwatch) {
      updateProductCardCustomBadges(activeOrFirstSwatch);
    }
  });
}

function updateProductCardPrice(target, targetVariantPrice) {
  if (target === null) return;
  if (targetVariantPrice === null || targetVariantPrice === '') return;
  const productCard = target.closest('.product-item');
  if (productCard && productCard.hasAttribute('data-product-split')) {
    let productCardVariantPrice = productCard.querySelector('.product-item__price');
    const compareAtPrice = target?.dataset?.variantComparePrice;
    const price = target.dataset.variantPrice;

    if (compareAtPrice) {
      productCardVariantPrice.innerHTML = `
        <span class="visually-hidden">Нормална Цена</span>
        <s class="t-subdued">${formatMoney$1(compareAtPrice, window.theme.moneyFormat)}</s>
        <span class="sale" data-price="">${formatMoney$1(price, window.theme.moneyFormat)}</span>
      `;
    } else {
      productCardVariantPrice.textContent = formatMoney$1(price, window.theme.moneyFormat);
    }
  }
}

function quantityInput(container) {
  if (!container) return;

  const quantityWrapper = container.querySelector('.quantity-input');
  if (!quantityWrapper) return;

  const quantityInput = quantityWrapper.querySelector('.quantity-input__input');
  const addQuantity = quantityWrapper.querySelector('.product__quantity-add-item');
  const subtractQuantity = quantityWrapper.querySelector('.product__quantity-subtract-item');
  const atcButtonQuantity = container.querySelector(".product-form__quantity input[name='quantity']");
  const handleAddQuantity = (e) => {
    e.preventDefault();
    const currentValue = parseInt(quantityInput.value);
    const newValue = currentValue + 1;
    quantityInput.value = newValue;
    atcButtonQuantity.value = newValue;
    quantityInput.dispatchEvent(new Event('change'));
  };

  const handleSubtractQuantity = (e) => {
    e.preventDefault();
    const currentValue = parseInt(quantityInput.value);
    if (currentValue === 1) return;
    const newValue = currentValue - 1;
    quantityInput.value = newValue;
    atcButtonQuantity.value = newValue;
    quantityInput.dispatchEvent(new Event('change'));
  };

  addQuantity.addEventListener('click', handleAddQuantity);
  subtractQuantity.addEventListener('click', handleSubtractQuantity);
}

function updateProductCardTitle(target, targetVariantTitle) {
  if (target === null) return;
  if (targetVariantTitle === null || targetVariantTitle === '') return;

  const productCard = target.closest('.product-item');
  if (productCard.dataset.showCustomTitle === 'true') return;

  if (productCard) {
    let productCardVariantTitle = productCard.querySelector('.product_item_variant_title');

    productCardVariantTitle.textContent = targetVariantTitle;
  }
}

function showHideTotalSwatchCountMobile(target) {
  const swatchesOverflowControlsWrapperMobile = target.closest('.product-swatches--overflow-controls-wrapper-mobile');

  const totalSwatchesCountMobile = swatchesOverflowControlsWrapperMobile.querySelector('.product-item__swatch-count');

  totalSwatchesCountMobile.classList.toggle('hide');
}

function showHideTotalSwatchCount(target) {
  if (target === null) return;

  const swatchesOverflowControlsWrapper = target.closest('.product-swatches--overflow-controls-wrapper');
  const totalSwatchesCount = swatchesOverflowControlsWrapper.querySelector('.product-item__swatch-count');

  totalSwatchesCount.classList.toggle('hide');
}

//toggle read more / read less on rich-text text block
function readMoreToggle() {
  const textToClamp = document.querySelector('.clamp-2-row-mobile');
  if (textToClamp === null) return;

  const readMoreElement = document.createElement('span');
  const readMoreText = document.createTextNode('Read more');
  const textElSmallHeight = textToClamp.offsetHeight + 'px';
  let textElFullHeight = textToClamp.scrollHeight + 'px';

  textToClamp.style.height = textElSmallHeight;
  readMoreElement.classList.add('read-more');

  readMoreElement.addEventListener('click', function () {
    if (textToClamp.classList.contains('clamp-2-row-mobile')) {
      textToClamp.classList.remove('clamp-2-row-mobile');
      textToClamp.style.height = textElFullHeight;
      this.innerHTML = 'Виж по-малко';
    } else {
      textToClamp.classList.add('clamp-2-row-mobile');
      textToClamp.style.height = textElSmallHeight;
      this.innerHTML = 'Виж още';
    }
  });

  readMoreElement.appendChild(readMoreText);
  if (window.innerWidth < 720) {
    textToClamp.insertAdjacentElement('afterend', readMoreElement);
  }

  window.addEventListener('resize', function () {
    if (window.innerWidth > 720) {
      textToClamp.style.height = 'auto';
      readMoreElement.classList.add('visually-hidden');
    } else {
      textElFullHeight = textToClamp.scrollHeight + 'px';
      textToClamp.style.height = textElSmallHeight;
      readMoreElement.classList.remove('visually-hidden');
    }
  });
}

function bindBundleShoppableItemEvent() {
  let shoppableItems = document.querySelectorAll('.shoppable-item-bundle');
  shoppableItems?.forEach((item) => {
    item.addEventListener('click', (event) => {
      shoppableItemShowProductInfo(event);
    });
  });
}

function shoppableItemShowProductInfo(event) {
  event.preventDefault();
  const target = event.currentTarget;
  let productInfo = target
    .closest('.shoppable-item-bundle-wrapper')
    .querySelector('.shoppable-item-product-info-wrapper');
  document.querySelectorAll('.shoppable-item-product-info-wrapper').forEach((item) => {
    item.classList.remove('visible');
  });
  productInfo.classList.toggle('visible');
}

function shoppableItemHideProductInfo() {
  document.addEventListener('click', (event) => {
    let shoppableBundleButtonWrappers = document.querySelectorAll('.shoppable-item__hotspot-wrapper');
    shoppableBundleButtonWrappers.forEach((wrapper) => {
      if (!wrapper.contains(event.target)) {
        wrapper.querySelector('.shoppable-item-product-info-wrapper').classList.remove('visible');
      }
    });
  });
}

//add to cart from product snippet
class ProductItemOptionSelect extends HTMLElement {
  constructor() {
    super();

    this.buttonVariantSelectQuerySelector = '.select-option-button';

    this.dropdown = this.querySelector('.option-select-dropdown-buttons');
    this.buttonTrigger = this.querySelector('.select-opener');
    this.buttonVariantSelect = this.querySelectorAll(this.buttonVariantSelectQuerySelector);

    this.wrapper = this.closest('.product-item');
    this.productForm = this.wrapper.querySelector('form.product-form');
    this.productFormVariant = this.productForm.querySelector('[data-variant-select]');
  }

  connectedCallback() {
    this.buttonTrigger.addEventListener('click', this.toggleDropdown.bind(this));
    this.buttonVariantSelect.forEach((btn) => {
      btn.addEventListener('click', this.selectVariant.bind(this));
    });
  }

  disconnectedCallback() {
    this.buttonTrigger.removeEventListener('click', this.toggleDropdown);
    this.buttonVariantSelect.forEach((btn) => {
      btn.removeEventListener('click', this.selectVariant);
    });
  }

  selectVariant(event) {
    var selected_variant = event.currentTarget.dataset.variantId;
    this.productFormVariant.value = selected_variant;
    //todo trigger form change to check variant availability
    this.updateProductItem(selected_variant);

    this.close();
  }

  updateProductItem(selected_variant) {
    var selected_button = this.querySelector(
      `${this.buttonVariantSelectQuerySelector}[data-variant-id='${selected_variant}']`,
    );
    var new_color_swatch = selected_button.dataset.colorSwatch;
    var new_image = selected_button.dataset.image;
    var new_name = selected_button.querySelector('.bundle-option-text').textContent;
    var new_price = (selected_button.dataset.price / 100).toFixed(2);
    new_price = window.theme.moneyFormat.replace('{{amount}}', new_price);

    this.buttonTrigger.querySelector('.select-opener-text').textContent = new_name;
    this.wrapper.querySelector('p.product-item__price').innerHTML =
      `<span class="product-item__price">${new_price}</span>`;
    if (new_color_swatch) {
      this.buttonTrigger.querySelector('.select-opener-color-swatch').style.background = new_color_swatch;
      this.buttonTrigger.querySelector('.select-opener-color-swatch').classList.remove('hide');
    } else {
      this.buttonTrigger.querySelector('.select-opener-color-swatch').classList.add('hide');
    }
    if (new_image && new_image.indexOf('no-image') < 0) {
      this.wrapper.querySelector('.product-item__image--one img').src = new_image;
      this.wrapper.querySelector('.product-item__image--one img').removeAttribute('srcset');
    }
  }

  toggleDropdown() {
    if (this.dropdown.classList.contains('opened')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.dropdown.classList.add('opened');
    this.buttonTrigger.classList.add('active');
  }

  close() {
    this.dropdown.classList.remove('opened');
    this.buttonTrigger.classList.remove('active');
  }
}
if (!window.customElements.get('product-item-option-select')) {
  window.customElements.define('product-item-option-select', ProductItemOptionSelect);
}
//end add to cart from product snippet

//cookie consent bar
class CookieConsentBar extends HTMLElement {
  constructor() {
    super();
    this.cookieBarWrapper = this.closest('.shopify-section');
    this.acceptButton = this.querySelector('#cookie-consent-bar-button');
    this.cookieName = 'nlbeauty-cookie-consent';
    this.cookieExpiresDays = 30;
  }

  connectedCallback() {
    this.onLoad();
    this.acceptButton.addEventListener('click', this.acceptCookie.bind(this));
  }

  disconnectedCallback() {
    this.acceptButton.removeEventListener('click', this.acceptCookie);
  }

  onLoad() {
    let isCookieAccepted = this.getCookie(this.cookieName);
    if (typeof isCookieAccepted != 'undefined' && isCookieAccepted) {
    } else {
      this.cookieBarWrapper.classList.remove('hidden');
    }
  }

  getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  acceptCookie() {
    const d = new Date();
    d.setTime(d.getTime() + this.cookieExpiresDays * 24 * 60 * 60 * 1000);

    document.cookie = this.cookieName + '=1;expires=' + d.toUTCString();
    this.cookieBarWrapper.classList.add('hidden');
  }
}

if (!window.customElements.get('cookie-consent-bar')) {
  window.customElements.define('cookie-consent-bar', CookieConsentBar);
}
//end cookie consent bar

class CustomAccordion extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      accordionRow: '.faq-section-block-wrapper',
      accordionTrigger: '.faq-section-block-title',
      accordionContent: '.faq-section-block-text',
    };

    this.settings = {
      disableDesktop:
        this.dataset.disableDesktop && (this.dataset.disableDesktop == 'true' || this.dataset.disableDesktop == 1),
      closeOtherOnNewOpen:
        this.dataset.closeOther && (this.dataset.closeOther == 'true' || this.dataset.closeOther == 1),
    };
    this.accordionRows = this.querySelectorAll(this.selectors.accordionRow);
    this.accordionTrigger = this.querySelectorAll(this.selectors.accordionTrigger);
  }

  connectedCallback() {
    this.accordionTrigger.forEach((trigger) => {
      trigger.addEventListener('click', this.toggleAccordion.bind(this));
    });
  }

  disconnectedCallback() {
    this.accordionTrigger.forEach((trigger) => {
      trigger.removeEventListener('click', this.toggleAccordion);
    });
  }

  toggleAccordion(event) {
    if (this.settings.disableDesktop && window.innerWidth >= 990) return false;
    var target_row = event.target.closest(this.selectors.accordionRow);

    if (target_row.classList.contains('active')) {
      this.close(target_row);
    } else {
      this.open(target_row);
    }
  }

  open(row) {
    if (this.settings.closeOtherOnNewOpen) {
      this.accordionRows.forEach((r) => this.close(r));
    }
    row.classList.add('active');
    var row_content = row.querySelector(this.selectors.accordionContent);
    row_content.style.setProperty('height', row_content.scrollHeight + 'px');
  }

  close(row) {
    row.classList.remove('active');
    row.querySelector(this.selectors.accordionContent).style.removeProperty('height');
  }
}
if (!window.customElements.get('custom-accordion')) {
  window.customElements.define('custom-accordion', CustomAccordion);
}

var CountDownTimer = class extends HTMLElement {
  constructor() {
    super();
    this.component = this;
    this.secondsEl = this.querySelector('.js-timer-seconds');
    this.minutesEl = this.querySelector('.js-timer-minutes');
    this.hoursEl = this.querySelector('.js-timer-hours');
    this.daysEl = this.querySelector('.js-timer-days');
    this.counterType = this.dataset.timerType;
    if (this.counterType === 'upsell-timer') {
      this.upsellPopup = this.closest('upsell-popup');
    }
  }

  connectedCallback() {
    if (this.counterType != 'upsell-timer') {
      this.startTimer();
    }
  }

  disconnectedCallback() {}

  startTimer() {
    if (this.counterType === 'upsell-timer') {
      const minutesRaw = (this.dataset.time || '').trim();
      const minutes = Number(minutesRaw);
      if (!minutesRaw || !Number.isFinite(minutes) || minutes <= 0) return;
      const timerTime = minutes * 60 * 1000;
      this.endTime = new Date().getTime() + timerTime;
    } else {
      this.endTime = new Date(this.dataset.endDate).getTime();
    }
    this.updateTimer(this.component);
  }

  updateTimer(component) {
    let second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24,
      endTime = component.endTime,
      timeNow = new Date().getTime() + 1,
      timeLeft = endTime - timeNow;
    let tempString = '';

    if (timeLeft > 0) {
      if (component.secondsEl) {
        let seconds = Math.floor((timeLeft % minute) / second);
        seconds < 10 ? (tempString = '0' + seconds) : (tempString = seconds);
        component.secondsEl.innerHTML = tempString;
      }
      if (component.minutesEl) {
        let minutes = Math.floor((timeLeft % hour) / minute);
        minutes < 10 ? (tempString = '0' + minutes) : (tempString = minutes);
        component.minutesEl.innerHTML = tempString;
      }
      if (component.hoursEl) {
        let hours = Math.floor((timeLeft % day) / hour);
        hours < 10 ? (tempString = '0' + hours) : (tempString = hours);
        component.hoursEl.innerHTML = tempString;
      }
      if (component.daysEl) {
        let days = Math.floor(timeLeft / day);
        days < 10 ? (tempString = '0' + days) : (tempString = days);
        component.daysEl.innerHTML = tempString;
      }
      setTimeout(component.updateTimer, 1000, component);
    } else {
      if (component.counterType === 'upsell-timer') {
        component.upsellPopup?.CloseUpsell();
      }
    }
  }
};

if (!window.customElements.get('countdown-timer')) {
  window.customElements.define('countdown-timer', CountDownTimer);
}

function shortDescriptionReadMoreToggle() {
  let viewMoreLessButton = document.querySelector('.product-short-description-text > div > span.read-more-less-button');
  viewMoreLessButton?.addEventListener('click', function () {
    let viewMore = this.dataset.viewMore;
    let longText = this.closest('div').querySelector('span.short-description-long-text');
    let shortText = this.closest('div').querySelector('span.short-description-short-text');
    if (viewMore === 'true') {
      this.innerHTML = 'Виж По-малко';
      this.style.display = 'block';
      this.dataset.viewMore = 'false';
      longText.style.display = 'inline';
      shortText.style.display = 'none';
    } else {
      this.innerHTML = 'Виж Още';
      this.style.display = 'inline';
      this.dataset.viewMore = 'true';
      shortText.style.display = 'inline';
      longText.style.display = 'none';
    }
  });
}

function javyShowHideStickyBar(gemPageStickyBar) {
  let defaultStyleString =
    'transform: none; z-index: 99 !important; display: block; flex-wrap: unset; visibility: visible; position: fixed !important;bottom: 0 !important; left: 0 !important; ';
  let styleString = '';
  gemPageStickyBar.setAttribute('style', `${defaultStyleString}`);
  let scrollPos = window.scrollY;
  if (scrollPos >= 1600) {
    styleString = defaultStyleString + ' opacity: 1 !important;';
    gemPageStickyBar.setAttribute('style', `${styleString}`);
  } else {
    styleString = defaultStyleString + ' opacity: 0 !important;';
    gemPageStickyBar.setAttribute('style', `${styleString}`);
  }
  window.addEventListener('scroll', () => {
    scrollPos = window.scrollY;
    if (scrollPos >= 1600) {
      styleString = defaultStyleString + ' opacity: 1 !important;';
      gemPageStickyBar.setAttribute('style', `${styleString}`);
    } else {
      styleString = defaultStyleString + ' opacity: 0 !important;';
      gemPageStickyBar.setAttribute('style', `${styleString}`);
    }
  });
}

function celShowHideStickyBanner(banner, trigger) {
  let scrollPos = window.scrollY;
  let rect = trigger.getBoundingClientRect();
  let triggererPos = rect.bottom + scrollPos;
  let defaultStyleString = 'transform: none; z-index: 50;';
  let newStyleString = '';
  if (scrollPos > triggererPos) {
    newStyleString = defaultStyleString + ' opacity: 1 !important;';
  } else {
    newStyleString = defaultStyleString + ' opacity: 0 !important';
  }
  window.addEventListener('resize', function () {
    scrollPos = window.scrollY;
    rect = trigger.getBoundingClientRect();
    triggererPos = rect.bottom + scrollPos;
  });

  banner.setAttribute('style', `${newStyleString}`);
  window.addEventListener('scroll', function () {
    scrollPos = window.scrollY;
    if (scrollPos > triggererPos) {
      newStyleString = defaultStyleString + ' opacity: 1 !important;';
    } else {
      newStyleString = defaultStyleString + ' opacity: 0 !important;';
    }
    banner.setAttribute('style', `${newStyleString}`);
  });
}

// calcCollectionProductInfoHeight() used to measure each product card's meta
// height and write CSS variables so the hover state could position the meta
// with `top: calc(130px - var(--content-height))`. That approach was racey
// (fonts/images shifted the real height after measurement) and unnecessary —
// the meta is now CSS-only, anchored to the bottom of the wrapper with
// `position: absolute; bottom: 0; height: auto;` so it grows upward by its
// own natural content height. No JS measurement required.
function calcCollectionProductInfoHeight() {}

function getVisibleHeight(el) {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight;

  const top = Math.max(rect.top, 0);
  const bottom = Math.min(rect.bottom, windowHeight);

  return Math.max(0, bottom - top);
}

document.addEventListener(
  'DOMContentLoaded',
  function () {
    let javyCoffeStickyBar = document.querySelector('.javycoffee-mobile-sticky-bar');
    let celPageStickyBanner = document.querySelector('.cel-page-sticky-banner');
    let swatchesPopup = document.querySelectorAll('.product-item__variant-info-popup');
    if (celPageStickyBanner) {
      let trigger = document.querySelector('.cel-page-sticky-banner-trigger');
      celShowHideStickyBanner(celPageStickyBanner, trigger);
    }
    if (javyCoffeStickyBar) {
      javyShowHideStickyBar(javyCoffeStickyBar);
    }
    shortDescriptionReadMoreToggle();
    readMoreToggle();
    bindProductCardColorSwatchEvent(swatchesPopup);
    initializeProductCardBadges();
    bindBundleShoppableItemEvent();
    shoppableItemHideProductInfo();
    calcCollectionProductInfoHeight();
    if (!document.documentElement.dataset.swatchDelegationBound) {
      document.addEventListener('click', function (e) {
        const swatch = e.target.closest(
          'li.product-swatches-options__item--swatch:not(.product-swatches-options__item-overflow)',
        );
        if (swatch) {
          const isPopup = !!swatch.closest('.product-item__variant-info-popup');
          if (isPopup) {
            swatchSetActiveInPopup(swatch);
          } else {
            swatchSetActive(swatch);
          }
          return;
        }
        const overflowBtn = e.target.closest(
          'span.product-swatches-options__item-overflow, span.product-swatches-options__item-overflow-mobile',
        );
        if (overflowBtn) {
          showHideColorSwatches(overflowBtn);
          if (overflowBtn.classList.contains('product-swatches-options__item-overflow')) {
            showHideTotalSwatchCount(overflowBtn);
          }
          overflowBtn.classList.toggle('minus');
        }
      });
      document.documentElement.dataset.swatchDelegationBound = 'true';
    }
    const productItems = document.querySelectorAll('.product-item--show-variants-on-hover');
    productItems.forEach((item) => {
      const container = item.querySelector('.product-item__meta');
      if (container) {
        quantityInput(container);
      }
    });

    // Any announcement-type section in the header group (default bar, countdown bar, ...)
    const announcementSections = document.querySelectorAll(
      '.shopify-section-group-header-group.announcement-bar__outer-wrapper, .shopify-section-group-header-group.shopify-section--announcement-bar-countdown',
    );
    const setAnnouncementHeight = () => {
      const visibleHeight = Array.from(announcementSections).reduce((sum, el) => sum + getVisibleHeight(el), 0);
      document.documentElement.style.setProperty('--announcement-height', `${visibleHeight}px`);
    };
    if (announcementSections.length) {
      setAnnouncementHeight();
      window.addEventListener('scroll', setAnnouncementHeight, { passive: true });
      window.addEventListener('resize', setAnnouncementHeight);
      if ('ResizeObserver' in window) {
        const announcementResizeObserver = new ResizeObserver(setAnnouncementHeight);
        announcementSections.forEach((el) => announcementResizeObserver.observe(el));
      }
    }
  },
  false,
);

const quickSearchObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
      const quickSearch = document.getElementById('MainQuickSearch');
      if (quickSearch) {
        const isVisible = quickSearch.getAttribute('aria-hidden') === 'false';

        if (isVisible) {
          calcCollectionProductInfoHeight();
        }
      }
    }
  });
});

const searchResultsObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList' && mutation.target.classList.contains('quick-search__results')) {
      calcCollectionProductInfoHeight();
      bindProductCardColorSwatchEvent();
      initializeProductCardBadges();
    }
  });
});

const searchContainerObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const searchContainer = mutation.target;
      if (searchContainer.classList.contains('quick-search--visible')) {
        calcCollectionProductInfoHeight();
        initializeProductCardBadges();
        searchContainerObserver.disconnect();
      }
    }
  });
});

// Start observing the quick search element when it's available
const observeQuickSearch = () => {
  const quickSearch = document.getElementById('MainQuickSearch');
  if (quickSearch) {
    // Observe the main quick search element for aria-hidden changes
    quickSearchObserver.observe(quickSearch, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
    });

    // Also observe the quick search container for class changes
    searchContainerObserver.observe(quickSearch, {
      attributes: true,
      attributeFilter: ['class'],
    });

    // Also observe the search results container for content changes
    const searchResults = quickSearch.querySelector('.quick-search__results');
    if (searchResults) {
      searchResultsObserver.observe(searchResults, {
        childList: true,
        subtree: true,
      });
    }
  } else {
    // If quick search is not available yet, try again in a short while
    setTimeout(observeQuickSearch, 100);
  }
};

// Start observing when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeQuickSearch);
} else {
  observeQuickSearch();
}

// Delete if not used anymore
// var TiktokVideo = class extends HTMLElement {
//   constructor() {
//     super();
//     this.swiperId = this.querySelector(
//       ".swiper-container-tiktok.swiper-container"
//     ).id;
//   }

//   connectedCallback() {
//     this.swiperInit(this.swiperId);
//     this.querySelectorAll(".swiper-buttons-tiktok").forEach((button) => {
//       button.addEventListener("click", () => this.nextSlide());
//     });
//   }

//   swiperInit(swiperId) {
//     var tiktokSwiper = new Swiper(`#${swiperId}`, {
//       spaceBetween: 16,
//       slidesPerView: "auto",
//       centeredSlides: true,
//       roundLengths: true,
//       loopAdditionalSlides: 6,
//       speed: 550,
//       loop: true,

//       navigation: {
//         nextEl: ".swiper-button-next-tiktok",
//         prevEl: ".swiper-button-prev-tiktok",
//       },
//       slidesOffsetAfter: 0,
//       on: {
//         slideChange: function () {
//           var activeSlide = this.slides[this.activeIndex];
//           activeSlide
//             .closest(".swiper-container-tiktok")
//             .querySelectorAll("video")
//             .forEach(function (video) {
//               video.pause();
//             });
//           activeSlide.querySelector("video").play();
//           activeSlide
//             .closest(".swiper-container-tiktok")
//             .querySelectorAll(".tiktok-volume-controls")
//             .forEach(function (volumeControls) {
//               volumeControls.classList.add("tiktok-volume-controls-hide");
//             });
//           activeSlide
//             .querySelector(".tiktok-volume-controls")
//             .classList.remove("tiktok-volume-controls-hide");
//           let isVolume = activeSlide
//             .closest(".swiper-container.swiper-container-tiktok.swiper")
//             .getAttribute("data-volume");
//           if (isVolume === "true") {
//             activeSlide.querySelector("video").muted = false;
//             activeSlide
//               .querySelector(".tiktok-muted")
//               .classList.add("tiktok-volume-controls-hide");
//             activeSlide
//               .querySelector(".tiktok-unmuted")
//               .classList.remove("tiktok-volume-controls-hide");
//           } else {
//             activeSlide.querySelector("video").muted = true;
//             activeSlide
//               .querySelector(".tiktok-unmuted")
//               .classList.add("tiktok-volume-controls-hide");
//             activeSlide
//               .querySelector(".tiktok-muted")
//               .classList.remove("tiktok-volume-controls-hide");
//           }
//         },
//         click: function () {
//           var clickedSlide = this.clickedIndex;
//           this.slideTo(clickedSlide);
//         },
//       },
//     });
//   }

//   disconnectedCallback() {
//     this.querySelectorAll(".swiper-buttons-tiktok").forEach((button) => {
//       button.removeEventListener("click", () => this.nextSlide());
//     });
//   }

//   nextSlide() {
//     let activeSlide = this.querySelector(".swiper-slide-active");

//     this.querySelectorAll("video").forEach((video) => {
//       video.pause();
//     });

//     this.querySelectorAll(`.tiktok-volume-controls`).forEach((controller) => {
//       controller.classList.add("tiktok-volume-controls-hide");
//     });

//     let isVolume = activeSlide
//       .closest(".swiper-container.swiper-container-tiktok.swiper")
//       .getAttribute("data-volume");
//     if (isVolume === "true") {
//       activeSlide.querySelector("video").muted = false;
//       activeSlide
//         .querySelector(".tiktok-muted")
//         .classList.add("tiktok-volume-controls-hide");
//       activeSlide
//         .querySelector(".tiktok-unmuted")
//         .classList.remove("tiktok-volume-controls-hide");
//     } else {
//       activeSlide.querySelector("video").muted = true;
//       activeSlide
//         .querySelector(".tiktok-unmuted")
//         .classList.add("tiktok-volume-controls-hide");
//       activeSlide
//         .querySelector(".tiktok-muted")
//         .classList.remove("tiktok-volume-controls-hide");
//     }
//     this.querySelector(
//       ".swiper-slide-active .tiktok-volume-controls"
//     ).classList.remove("tiktok-volume-controls-hide");
//     this.querySelector(".swiper-slide-active video").play();
//   }
// };

// if (!window.customElements.get("tiktok-video")) {
//   window.customElements.define("tiktok-video", TiktokVideo);
// }

// var VolumeControls = class extends HTMLElement {
//   constructor() {
//     super();
//     this.tiktokMuted = this.querySelector(".tiktok-muted");
//     this.tiktokUnmuted = this.querySelector(".tiktok-unmuted");
//     this.swiper = this.closest(
//       ".swiper-container.swiper-container-tiktok.swiper"
//     );
//   }

//   connectedCallback() {
//     this.tiktokMuted.addEventListener("click", (event) => this.unmute(event));

//     this.tiktokUnmuted.addEventListener("click", (event) => this.mute(event));
//   }

//   disconnectedCallback() {
//     this.tiktokMuted.removeEventListener("click", (event) =>
//       this.unmute(event)
//     );
//     this.tiktokUnmuted.removeEventListener("click", (event) =>
//       this.mute(event)
//     );
//   }
//   mute() {
//     this.closest(".swiper-slide").querySelector("video").muted = true;
//     this.tiktokUnmuted.classList.add("tiktok-volume-controls-hide");
//     this.tiktokMuted.classList.remove("tiktok-volume-controls-hide");
//     this.swiper.setAttribute("data-volume", "false");
//   }
//   unmute() {
//     this.closest(".swiper-slide").querySelector("video").muted = false;
//     this.tiktokMuted.classList.add("tiktok-volume-controls-hide");
//     this.tiktokUnmuted.classList.remove("tiktok-volume-controls-hide");
//     this.swiper.setAttribute("data-volume", "true");
//   }
// };

// if (!window.customElements.get("volume-control")) {
//   window.customElements.define("volume-control", VolumeControls);
// }

document.addEventListener('click', function (event) {
  const btn = event.target.closest('[data-show-more-products]');
  if (!btn) return;
  const container = btn.closest('.collection__container') || document;
  const hiddenDesktopItems = container.querySelectorAll('.product-item-hidden-desktop');
  const hiddenMobileItems = container.querySelectorAll('.product-item-hidden-mobile');
  hiddenDesktopItems.forEach((item) => item.classList.remove('product-item-hidden-desktop'));
  hiddenMobileItems.forEach((item) => item.classList.remove('product-item-hidden-mobile'));
  const allWrappers = container.querySelectorAll('.collection__show-more-wrapper');
  allWrappers.forEach((wrapper) => {
    wrapper.style.display = 'none';
  });
  if (typeof calcCollectionProductInfoHeight === 'function') {
    calcCollectionProductInfoHeight();
  }
});

// Upsell slider cart

const initSlider = (root) => {
  const update = () => {
    const track = root.querySelector('.cross-sells__items');
    const prevBtn = root.querySelector('.cross-sells__slider-button--prev');
    const nextBtn = root.querySelector('.cross-sells__slider-button--next');
    if (!track || !prevBtn || !nextBtn) return;
    const max = Math.max(0, track.scrollWidth - track.clientWidth - 1);
    const hasOverflow = track.scrollWidth > track.clientWidth + 1;
    prevBtn.disabled = !hasOverflow || track.scrollLeft <= 0;
    nextBtn.disabled = !hasOverflow || track.scrollLeft >= max;
    prevBtn.hidden = !hasOverflow;
    nextBtn.hidden = !hasOverflow;
  };

  if (root.dataset.sliderInit === 'true') {
    update();
    return;
  }
  root.dataset.sliderInit = 'true';

  const getStep = (track) => {
    const item = track.querySelector('.cross-sells__item');
    if (!item) return 280;
    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.gap || styles.columnGap || '0');
    return item.getBoundingClientRect().width + gap;
  };

  root.addEventListener('click', (e) => {
    const btn = e.target.closest('.cross-sells__slider-button--prev, .cross-sells__slider-button--next');
    if (!btn || !root.contains(btn)) return;
    const track = root.querySelector('.cross-sells__items');
    if (!track) return;
    const dir = btn.classList.contains('cross-sells__slider-button--prev') ? -1 : 1;
    track.scrollBy({left: dir * getStep(track), behavior: 'smooth'});
  });

  root.addEventListener(
    'scroll',
    (e) => {
      if (e.target.matches?.('.cross-sells__items')) update();
    },
    {capture: true, passive: true},
  );

  window.addEventListener('resize', update);
  update();
};
const boot = () => {
  document.querySelectorAll('.cross-sells.cross-sells-list').forEach(initSlider);
};
boot();
new MutationObserver(boot).observe(document.body, {childList: true, subtree: true});

class FAQSection extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.js-faq-search');
    this.items = [...this.querySelectorAll('.js-faq-item')];
    this.groups = [...this.querySelectorAll('.js-faq-group')];
    this.navItems = [...this.querySelectorAll('.js-faq-nav-item')];
    this.emptyState = this.querySelector('.js-faq-empty');

    this.navMap = new Map();
    this.navItems.forEach(nav => {
      const link = nav.querySelector('[data-group]');
      if (link) {
        this.navMap.set(link.dataset.group, nav);
      }
    });

    if (this.input) {
      this.initSearch();
    }

    this.initScrollSpy();
    this.setInitialActive();
    this.mobileNavToggle();
    this.bindNavClicks();
    this.bindAccordionEvents();
  }

  initSearch() {
    let timeout;

    this.input.addEventListener('input', (e) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.handleSearch(e.target.value);
      }, 200);
    });
  }

  getHeaderHeight() {
    const value = getComputedStyle(document.documentElement)
      .getPropertyValue('--height-header')
      .trim();

    return parseInt(value) || 0;
  }

  initScrollSpy() {
    const updateActive = () => {
      const headerOffset = this.getHeaderHeight();
      const activationOffset = headerOffset + 10;

      let current = null;

      this.groups.forEach(group => {
        if (group.classList.contains('is-hidden')) return;

        const rect = group.getBoundingClientRect();

        if (rect.top <= activationOffset) {
          current = group;
        }
      });

      if (!current) {
        current = this.groups.find(group => {
          if (group.classList.contains('is-hidden')) return false;
          return group.getBoundingClientRect().top > 0;
        });
      }

      if (current) {
        this.setActiveNav(current.dataset.group);
      }
    };

    let ticking = false;

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateActive();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateActive);

    this.updateActive = updateActive;
    updateActive();
  }

  handleSearch(query) {
    const normalized = query.toLowerCase().trim();

    if (!normalized) {
      this.reset();
      return;
    }

    const words = normalized.split(' ').filter(Boolean);

    this.items.forEach(item => {
      const text = this.getItemText(item);
      const match = this.matches(words, text);
      item.classList.toggle('is-hidden', !match);
    });

    this.updateGroups();
    this.updateEmptyState();
    this.scrollToFirstVisible();
  }

  getItemText(item) {
    return (
      item.dataset.question + ' ' +
      item.dataset.answer + ' ' +
      item.dataset.keywords
    );
  }

  matches(words, text) {
    return words.every(word => text.includes(word));
  }

  updateGroups() {
    this.groups.forEach(group => {
      const visibleItems = group.querySelectorAll('.js-faq-item:not(.is-hidden)');
      const isVisible = visibleItems.length > 0;

      group.classList.toggle('is-hidden', !isVisible);

      const nav = this.navMap.get(group.dataset.group);
      if (nav) {
        nav.classList.toggle('is-hidden', !isVisible);
      }
    });
  }

  updateEmptyState() {
    const anyVisible = this.items.some(i => !i.classList.contains('is-hidden'));

    if (this.emptyState) {
      this.emptyState.classList.toggle('is-visible', !anyVisible);
    }
  }

  reset() {
    this.items.forEach(item => item.classList.remove('is-hidden'));
    this.groups.forEach(group => group.classList.remove('is-hidden'));
    this.navItems.forEach(nav => nav.classList.remove('is-hidden'));

    if (this.emptyState) {
      this.emptyState.classList.remove('is-visible');
    }
  }

  scrollToFirstVisible() {
    const first = this.items.find(i => !i.classList.contains('is-hidden'));

    if (!first) return;

    const closestGroup = first.closest('.js-faq-group');

    closestGroup.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  setActiveNav(activeKey) {
    this.navItems.forEach(nav => nav.classList.remove('is-active'));
    const active = this.navMap.get(activeKey);
    if (active) {
      active.classList.add('is-active');
    }
  }

  setInitialActive() {
    const firstVisible = this.groups.find(g => !g.classList.contains('is-hidden'));
    if (firstVisible) {
      this.setActiveNav(firstVisible.dataset.group);
    }
  }

  mobileNavToggle() {
    const toggleButton = this.querySelector('.js-mobile-nav-toggle');

    if (toggleButton) {
      toggleButton.addEventListener('click', () => {
        toggleButton.closest('.js-faq-nav').classList.toggle('is-active');
      });
    }
  }

  bindNavClicks() {
    this.navItems.forEach(nav => {
      const link = nav.querySelector('.js-faq-nav-item-link');
  
      if (!link) return;
  
      link.addEventListener('click', () => {
        const navWrapper = this.querySelector('.js-faq-nav');
  
        if (navWrapper && navWrapper.classList.contains('is-active')) {
          navWrapper.classList.remove('is-active');
        }
      });
    });
  }

  bindAccordionEvents() {
    this.addEventListener('click', (e) => {
      const trigger = e.target.closest('.collapsible-row-list-item__trigger');
      if (!trigger) return;

      requestAnimationFrame(() => {
        if (this.updateActive) {
          this.updateActive();
        }
      });
    });
  }
}

customElements.define('faq-section', FAQSection);
